import React from 'react';
import {RoleAssignment, RoleAssignmentSwitch} from '@touchnet/user-management';

import type {FC} from 'react';
import type {RoleAssignmentResource} from '@tn-types/users-roles-permissions-storage';

import {ErpRoles} from "~/components/pages/user-mgmt/types/urps-types";
import ErpAdminRoleAssignment from "~/components/pages/user-mgmt/roles/erp-admin-role-assignment";

interface ComponentProps {
    assignment: RoleAssignmentResource;
    urn: string;
}

export const RoleAssignmentDisplay: FC<ComponentProps> = ({assignment, urn}: ComponentProps) => {
    return (
        <RoleAssignmentSwitch assignment={assignment} urn={urn}>
            <RoleAssignment codes={[ErpRoles.ERP_ADMIN]} roleName={'ERP Admin'}>
             <ErpAdminRoleAssignment />
            </RoleAssignment>
        </RoleAssignmentSwitch>
    );
};

export default RoleAssignmentDisplay;
